export const SUB_PROFILES_FETCH = 'SUB_PROFILES_FETCH';
export const SUB_PROFILES_IS_FETCING = 'SUB_PROFILES_IS_FETCING';
export const SUB_PROFILES_API = 'subprofiles';
export const SUB_PROFILE_EDIT = 'SUB_PROFILE_EDIT';
export const SUB_PROFILE_SAVE = 'SUB_PROFILE_SAVE';
export const SUB_PROFILE_FILTER = 'SUB_PROFILE_FILTER';
export const SINGLE_SUB_PROFILE_FETCH = 'SINGLE_SUB_PROFILE_FETCH';
export const SUB_PROFILES_ABS_REBATE_VALUES_FETCH = 'SUB_PROFILES_ABS_REBATE_VALUES_FETCH';



// WEBPACK FOOTER //
// ./src/constants/subProfiles.js